import { ConstellationOneListing, isDefined, isUndefined } from '@aloft/toolkit-shared';
import { Flex } from '@aloft/toolkit-sui';

import { useMemo, useRef } from 'react';

import { LoadingScreen } from '../../components/LoadingScreen/LoadingScreen.tsx';
import { useStreetView } from '../../hooks/googleMaps/useStreetView.ts';
import { NoData } from './NoData.tsx';

export const Tkv2MlsStreetView = ({
  isPopout,
  listingData,
  address,
}: {
  isPopout: boolean;
  listingData: ConstellationOneListing;
  address: string;
}) => {
  const streetViewRef = useRef<HTMLDivElement>(null);

  const position = useMemo(
    () =>
      isDefined(listingData.Latitude) && isDefined(listingData.Longitude)
        ? { lat: listingData.Latitude, lng: listingData.Longitude }
        : undefined,
    [listingData.Latitude, listingData.Longitude],
  );

  const status = useStreetView(address, position, streetViewRef);

  if (isUndefined(position) && !address) {
    return <NoData text="No property location available" />;
  }

  let content = null;

  if (status === 'pending') {
    content = <LoadingScreen what="Streetview" />;
  }

  if (status === 'error') {
    content = <NoData text="Google Street View is not available for this property" />;
  }

  return (
    <>
      <Flex
        ref={streetViewRef}
        height="100%"
        width="100%"
        position="absolute"
        overflow="hidden"
        top={isPopout ? '2.5rem' : '0'}
      >
        {content}
      </Flex>
    </>
  );
};
